import { address_form_strings } from "./components/address-form/AddressForm.strings.ts";

export const sdkStrings = {
  address_form_strings,
};
